import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./scss/main.css";
import {BrowserRouter, Route, Redirect, Switch} from "react-router-dom";
import Nav from "./components/nav/nav.js";
import GroupInvitation from './components/group-invitation/GroupInvitation';

ReactDOM.render(
    <BrowserRouter>
        <div>       
            <Nav />

            <div className="container">
                <main>
                    <Switch>
                        <Route path="/group/invitation" component={GroupInvitation} />                        
                    </Switch>
                </main>
            </div>
        </div>
    </BrowserRouter>
    , document.getElementById('root'), () => {});

//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js